import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/api";
import { useAuth } from "@/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", location.pathname);
        setUser(data);
        const owner = data.role === "super_admin" || data.is_workspace_owner;
        nav(owner ? (data.role === "super_admin" && !data.active_tenant_id ? "/choose-workspace" : "/admin") : "/welcome", { replace: true });
      } catch (e) {
        const d = e.response?.data?.detail;
        toast.error(typeof d === "string" ? d : "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground" data-testid="auth-callback">
      Signing you in with Google…
    </div>
  );
}
